/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationResourceAggregationRequest {
    getFixupPrototypeFunction() { return UtilizationResourceAggregationRequest.fixupPrototype; }

    static newInstance(model: Partial<UtilizationResourceAggregationRequest>): UtilizationResourceAggregationRequest {
        let obj = Object.assign(new UtilizationResourceAggregationRequest(), model);
        UtilizationResourceAggregationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationResourceAggregationRequest>): UtilizationResourceAggregationRequest {
        if (!model) return null;
        return UtilizationResourceAggregationRequest.newInstance(<UtilizationResourceAggregationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationResourceAggregationRequest) {
        if (!obj) return;

        models.UtilizationResourceAggregationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationResourceAggregationRequest): boolean {
        Object.setPrototypeOf(obj, UtilizationResourceAggregationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
    }

    /**
     * Service account id
     */
    service_account_id: string;

    /**
     * Unique id of the resource
     */
    check_resource_element: string;

    /**
     * Aggregation of the resource
     */
    aggregation: string;

    /**
     * metric name
     */
    metric_name: Array<string>;

    /**
     * specify the start date.
     */
    from_date: Date;

    /**
     * specify the end date.
     */
    to_date: Date;

}
